import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, Header, Image, Input, Button, Popup} from "semantic-ui-react";
import { useDropzone } from 'react-dropzone';
import CardLoader from "../Pagination/CardLoader";
import "../../styles/Organizations.css";
import OrganizationLandingPage from "./OrganizationLandingPage";
import CardPaginationTable from "../Pagination/CardPaginationTable";
import { fetchOrganisations, addOrganization, resetAddOrganizationStatus, updateOrganization, resetUpdateOrganizationStatus } from "../../actions/adminConsoleAction";

const Organisations = ({
  setOrganisationCount,
  showToaster,
  dataFromChild,
  openOrganisationAdd,
  handleCloseOrganisationAdd,
  handleOpenOrganisationAdd,
  filteredOrganisations,
  setEditModeOn,
  setEditModeOff,
  editMode,
}) => {
  const dispatch = useDispatch();
  const { organisations, loading, error, addOrganizationStatus, updateOrganizationStatus } = useSelector((state) => state.admin);

  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [lengthError, setLengthError] = useState(true);
  const [specialChar, setSpecialChar] = useState(true);
  const [datasetExistError, setDatasetExistError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [data, setData] = useState([]);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [LoaderFlag, setLoaderFlag] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(9);
  const [inputDescriptionValue, setInputDescriptionValue] = useState("");
  const [inputEmailValue, setInputEmailValue] = useState("");
  const [logoBase64, setLogoBase64] = useState("");
  const [inputAdminNameValue, setInputAdminNameValue] = useState("");
  const [editOrganizationId, setEditOrganizationId] = useState(null);
  const [specialCharError, setSpecialCharError] = useState('');
 

  const isMounted = useRef(false);

  useEffect(() => {
    if (!isMounted.current) {
      dispatch(fetchOrganisations());
      isMounted.current = true;
    }
  }, [dispatch]);

  useEffect(() => {
    if (!loading) {
      setLoadingData(false);
      setData(filteredOrganisations || organisations);
    } else {
      setLoadingData(true);
    }
  }, [loading, filteredOrganisations, organisations]);

  useEffect(() => {
    
    if (addOrganizationStatus !== null) {
      if (addOrganizationStatus === 200) {
        showToaster("Organization successfully added", "success");
        setOrganisationCount(prevCount => prevCount + 1);
        // Fetch the latest list of organizations to ensure the new one is included
        dispatch(fetchOrganisations());
      } else {
        showToaster("Failed to add organization", "error");
      }
      dispatch(resetAddOrganizationStatus());
    }
  }, [addOrganizationStatus, showToaster, setOrganisationCount, dispatch]);

  
  useEffect(() => {
    
    if (updateOrganizationStatus !== null) {
      if (updateOrganizationStatus === 200) {
        showToaster("Organization successfully updated", "success");
      
      } else {
        showToaster("Failed to update organization", "error");
      }
      dispatch(resetUpdateOrganizationStatus());
      dispatch(fetchOrganisations());
    }
  }, [updateOrganizationStatus, showToaster, dispatch]);

  

  useEffect(() => {
    setOrganisationCount(data.length);
  }, [data, setOrganisationCount]);


  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleClose = () => {
    handleCloseOrganisationAdd();
    setDatasetExistError("");
    setInputValue("");
    setInputDescriptionValue("");
    setInputEmailValue("");
    setInputAdminNameValue("");
    setSpecialChar(true);
    setEmailError("");
    setLogoBase64("");
    setEditModeOff();
  };

  const handleDataSet = async () => {
    handleClose();
  
    if (isButtonEnabled) {
      const defaultLogoPath = "/images/favicon.png";
      const requestData = {
        orgName: inputValue,
        orgAdminName: inputAdminNameValue,
        orgAdminCommunicationEmail: inputEmailValue,
        logoBase64: logoBase64 || defaultLogoPath, // Set default logo if none is uploaded
        orgDescription: inputDescriptionValue,
      };
  
      try {
        const newOrganization = await dispatch(addOrganization(requestData));
        setData(prevData => [newOrganization, ...prevData]);
        setLoaderFlag(false);
      } catch (error) {
        console.error("There was a problem with the fetch operation:", error);
        showToaster("Failed to add organization", "error");
      }
    }
  };
  

  const validateForm = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailRegex.test(inputEmailValue);
    const isInputValueValid = inputValue.length > 0 && specialChar && lengthError && !datasetExistError;
    const isAdminNameValid = inputAdminNameValue.length > 0;   
    setIsButtonEnabled(isInputValueValid && isAdminNameValid && isEmailValid);
  
  };

  useEffect(() => {
    validateForm();
  }, [inputValue, inputDescriptionValue, inputEmailValue, inputAdminNameValue, datasetExistError, emailError]); // Change: Added this useEffectZz

  const handleChange = (event) => {
    setDatasetExistError("");
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s'_\-()]/g, ''); // Allow only alphabetic characters, spaces, hyphens, and apostrophes // Remove special characters
    setInputValue(value);
    setSpecialChar(value === sanitizedValue);
    setLengthError(sanitizedValue.length <= 30);

    if (value !== sanitizedValue) {
      setSpecialCharError("Special characters are not allowed"); // Set error message
    } else {
      setSpecialCharError(''); // Clear error message
    }

  if (value === sanitizedValue) { 
    const datasetExists = (filteredOrganisations || organisations).some(
      (dataset) => dataset.orgName.toLowerCase() === sanitizedValue.toLowerCase()
    );
    if (datasetExists) {
      setDatasetExistError("Organization name already exists");
    }else{
      setDatasetExistError("");
    }
  }

    validateForm();
  };

  const handleDescriptionChange = (event) => {
    const value = event.target.value;
    setInputDescriptionValue(value);
    validateForm();
  };

  const handleEmailChange = (event) => {
    const value = event.target.value;
    setInputEmailValue(value);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (value && !emailRegex.test(value)) {
      setEmailError("Invalid email");
    } else {
      setEmailError("");
    }

    validateForm();
  };

  const handleAdminNameChange = (event) => {
    const value = event.target.value;
    setInputAdminNameValue(value);
    validateForm();
  };

  const handleEditOrganization = (organization) => {
    setEditModeOn();
    setEditOrganizationId(organization._id);
    setInputValue(organization.orgName);
    setInputDescriptionValue(organization.orgDescription);
    setInputEmailValue(organization.orgAdminCommunicationEmail);
    setInputAdminNameValue(organization.orgAdminName);
    setLogoBase64(organization.logoBase64 || "");
    handleOpenOrganisationAdd();

  };

  const handleDisableOrganization = (organization) => {
    setEditOrganizationId(organization._id);
    setInputValue(organization.orgName);
    setInputDescriptionValue(organization.orgDescription);
    setInputEmailValue(organization.orgAdminCommunicationEmail);
    setInputAdminNameValue(organization.orgAdminName);
    setLogoBase64(organization.logoBase64 || "");

     let organizationData = {
      orgName: organization.orgName,
      orgDescription: organization.orgDescription,
      orgAdminName: organization.orgAdminName,
      disabled:true,
      orgId: organization._id,
    };

    dispatch(updateOrganization(organizationData))
  };


  const handleEnableOrganization = (organization) => {
    setEditOrganizationId(organization._id);
    setInputValue(organization.orgName);
    setInputDescriptionValue(organization.orgDescription);
    setInputEmailValue(organization.orgAdminCommunicationEmail);
    setInputAdminNameValue(organization.orgAdminName);
    setLogoBase64(organization.logoBase64 || "");

     let organizationData = {
      orgName: organization.orgName,
      orgDescription: organization.orgDescription,
      orgAdminName: organization.orgAdminName,
      disabled:false,
      orgId: organization._id,
    };

    dispatch(updateOrganization(organizationData))
  };

  const closeModal = () => {
    setInputValue("");
    setInputDescriptionValue("");
    setInputEmailValue("");
    setInputAdminNameValue("");
    setLogoBase64("");
    setLengthError(true);
    setSpecialChar(true);
    setEmailError("");
    setEditModeOff();
    setEditOrganizationId(null);
    handleCloseOrganisationAdd(false);
    setIsButtonEnabled(false);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpeg", ".jpg"],
      "image/svg+xml": [".svg"], 
    },
    onDrop: (acceptedFiles) => {
      const file = acceptedFiles[0];
      const reader = new FileReader();
      reader.onloadend = () => {
        setLogoBase64(reader.result);
      };
      reader.readAsDataURL(file);
    }
  });

  const handleSave = () => {
    let organizationData;
  
    if (editMode) {
      organizationData = {
        orgName: inputValue,
        orgDescription: inputDescriptionValue,
        orgAdminName: inputAdminNameValue,
        logoBase64,
        orgId: editOrganizationId,
      };
    } else {
      organizationData = {
        orgName: inputValue,
        orgDescription: inputDescriptionValue,
        orgAdminCommunicationEmail: inputEmailValue,
        orgAdminName: inputAdminNameValue,
        logoBase64,
      };
    }

    // Additional code to handle saving the organization data  
    if (editMode) {
      dispatch(updateOrganization(organizationData))
    } else {
      dispatch(addOrganization(organizationData));
    }
    // handleCloseOrganisationAdd(false);  // Close the modal
    closeModal();
  };

  const handleRemoveLogo = () => {
    setLogoBase64("");
  };

  const dropzoneStyles = {
    border: "2px dashed #d3d3d3",
    borderRadius: "4px",
    padding: "20px",
    textAlign: "center",
    cursor: "pointer",
  };

  const columns = [
    { id: "datasetName", label: "Organization name" },
    { id: "files", label: "Admin" },
    { id: "accessUsers", label: "Joining Date" },
  ];

  return (
    <div>
      <div className="hide-add-organization-button-mobile">
        <Button
          primary
          onClick={handleCloseOrganisationAdd}
          className="button-data-console"
          data-cy="add-organization-btn-link"
        >
          <div className="button-data-console-parent">
            <Image src="/images/white-base-icons.svg" alt="Add new Organization" />
            Add new Organization
          </div>
        </Button>
      </div>
      {loadingData ? (
        <CardLoader numCards={20} />
      ) : data.length > 0 ? (
        <>
          <div>
            <OrganizationLandingPage
              columns={columns}
              data={data.slice(
                currentPage * rowsPerPage,
                (currentPage + 1) * rowsPerPage
              )}
              showToaster={showToaster}
              setDeleteStatus={setDeleteStatus}
              loaderFlag={LoaderFlag}
              handleEditOrganization={handleEditOrganization}
              handleDisableOrganization={handleDisableOrganization}
              handleEnableOrganization={handleEnableOrganization}
            />
            <CardPaginationTable
              totalItems={data.length}
              page={currentPage}
              rowsPerPage={rowsPerPage}
              handleChangePage={handleChangePage}
            />
          </div>
        </>
      ) : (
        <div className="emptyContainer">
          <Image src="/images/empty-state.svg" alt="Empty State" />
          <p className="emptyMessage">
            <span className="titleMessage">No Organisations available </span>
          </p>
        </div>
      )}
      <Modal
        open={openOrganisationAdd}
        onClose={closeModal}
        size="tiny"
        className="add-document-model"
      >
        <Modal.Header className="modal-header">
        <Header as="h3"> {editMode ? "Edit Organization":"Create new organization"}</Header>
        </Modal.Header>
        <Modal.Content data-cy="error-message-cy">
          <label className="form-label">Organization Name *</label>
          <Input
            type="text"
            value={inputValue}
            onChange={handleChange}
            placeholder="Add name"
            className="add-organization-input"
            data-cy="organization-input-cy"
          />
          {inputValue.length > 0 && inputValue.length > 30 && (
            <span className="error-text" style={{ color: 'red' }}>
              &nbsp;Maximum limit 30 characters.
            </span>
          )}
           {!specialChar && <span className="error-message" style={{ color: 'red' }}>{specialCharError}</span>}
          {inputValue.length > 0 && datasetExistError.length > 0 && (
            <span className="error-text" style={{ color: 'red' }}>&nbsp;{datasetExistError}</span>
          )}
          <label className="form-label">Organization Description</label>
          <div style={{opacity:'.45',borderRadius:'5px'}} className="add-organisation-description-textarea">
            <textarea
              rows="4"
              cols="50"
              className="add-datset-input"
              data-cy="dataset-description-cy"
              onChange={handleDescriptionChange}
              value={inputDescriptionValue}
            />
          </div>
          {inputDescriptionValue.length > 80 && (
            <span className="error-text" style={{ color: 'red' }}>
              &nbsp;Description limit is 80 characters.
            </span>
          )}
          <label className="form-label">Admin name *</label>
          <Input
            type="text"
            placeholder="Add admin name"
            className="add-organization-input"
            data-cy="admin-name-cy"
            value={inputAdminNameValue}
            disabled={editMode}
            onChange={handleAdminNameChange}
          />
          <label className="form-label">Admin email *</label>
          <Input
            type="email"
            placeholder="Add admin email"
            className="add-organization-input"
            data-cy="admin-email-cy"
            value={inputEmailValue}
            disabled={editMode}
            onChange={handleEmailChange}
            style={editMode ? { backgroundColor: "#f0f0f0", cursor: "not-allowed" } : {}}
            
          />
          {emailError && (
            <span className="error-text" style={{ color: 'red' }}>
              &nbsp;{emailError}
            </span>
          )}
          <label className="form-label" style={{display:'flex'}}>Organization Logo (optional) 
          <Popup
              inverted
              position="right center"
              trigger={
                <Image
                  className="pdfHoverImg"
                  src="/images/Info.svg"
                  alt="Info"
                />
              }
              style={{ borderRadius: "15px" }}
            >
              <div>
                <div>Accepted image types are: <br/> PNG, JPEG, JPG, and SVG.</div>
              </div>
            </Popup>
            </label>
          {logoBase64 ? (
      <div className="logo-upload-container">
    <Image src={logoBase64} size='small' className="addLogo" />
    <div className="logo-buttons">
      <Button onClick={handleRemoveLogo} className="removeButton" color='red'>Remove</Button>
      <Button {...getRootProps()} className="uploadButton" color='blue'>Upload</Button>
    </div>
  </div>
) : (
  <div className="dragBoxOrg" {...getRootProps()} style={dropzoneStyles}>
    <input {...getInputProps()} />
    {isDragActive ? (
      <p>Drop files here...</p>
    ) : (
      <>
        <div className="upload-button-div" data-cy="upload-button-div-cy">
          <Image src="/images/blue-upload.svg" alt="Upload" />
          <div>Upload</div>
        </div>
      </>
    )}
  </div>
)}


        </Modal.Content>
        <Modal.Actions>
          <Button
            className="cancel-btn"
            onClick={closeModal}
            data-cy="organization-cancel-submit-btn"
          >
            Cancel
          </Button>
          <Button
            disabled={!isButtonEnabled}
            className="add-btn"
            onClick = {handleSave}
            data-cy="organization-submit-btn"
            primary
          >
            {editMode ? "Update" : "Create"}
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default Organisations;
